import * as Sentry from "@sentry/react"
import React, { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useApp } from "../AppProvider"

export const Logout: React.FC = () => {
  const { setToken, setUser } = useApp()
  const navigate = useNavigate()

  useEffect(() => {
    setToken(undefined)
    setUser(undefined)
    Sentry.setUser(null)
    navigate("/login")
  }, [setToken, setUser, navigate])

  return null
}
